import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=024ecff5&scoped=true&"
import script from "./SearchResult.vue?vue&type=script&lang=ts&"
export * from "./SearchResult.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=024ecff5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ecff5",
  null
  
)

component.options.__file = "SearchResult.vue"
export default component.exports